/**
 * Marca da plataforma: lockup do designer (wordmark "medverse" + glifo orbital).
 *
 * PNG e não SVG porque é o que veio da agência; o arquivo é um derivado de
 * `design/brand/LOGO-04.png` reduzido para ~2x do maior uso em tela. Como é a
 * primeira coisa pintada na home pública, o request é antecipado por um
 * `<link rel="preload">` no index.html.
 *
 * A arte é branco + magenta fixos: só funciona sobre o fundo escuro do tema
 * (`medverse-theme`). Não reaproveitar fora dele.
 */

import React from 'react';

/** Dimensões do arquivo — declaradas no <img> para não causar layout shift. */
const LOGO_WIDTH = 240;
const LOGO_HEIGHT = 123;

interface MedverseLogoProps {
  className?: string;
  /** Versão reduzida, para a topbar mobile. */
  compact?: boolean;
}

const MedverseLogo: React.FC<MedverseLogoProps> = ({ className = '', compact = false }) => (
  <img
    src="/assets/logos/medverse-logo.png"
    alt="Medverse"
    width={LOGO_WIDTH}
    height={LOGO_HEIGHT}
    /* O wordmark ocupa só ~24% da altura do lockup (o glifo é bem mais alto),
       então alturas menores que estas deixam o texto ilegível. */
    className={`w-auto select-none ${compact ? 'h-11' : 'h-14'} ${className}`}
    fetchPriority="high"
    decoding="async"
    draggable={false}
  />
);

export default MedverseLogo;
